/* eslint-disable jsx-a11y/alt-text */
import { ArrowLeftIcon, ChevronDownIcon } from "@heroicons/react/outline";
import { LinearProgress } from "@mui/material";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { decryptNik } from "Config/cripto";
import { fetchApi } from "Config/fetchApi";
import { fetchApiFormdata } from "Config/fetchApiFormdata";
import { fetchImageUrl } from "Config/fetchImage";
import { blobToBase64, fetchImageAsBlob } from "Config/urltoBase64";
import {
  base64ToFile,
  displayBinaryImage,
  fileToBase64,
  handleError,
  handleSuccess,
  handleWarning,
  isoStringToDateInput,
} from "Helper";
import moment from "moment";
import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";

function UpdateWatchlist() {
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  // console.log(argumentData, "argumentData");
  const fileInputRef = useRef(null);
  const prevUuidRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [dataGender, setDataGender] = useState([]);
  const [dataBloodType, setDataBloodType] = useState([]);
  const [dataReligion, setDataReligion] = useState([]);
  const [dataMaritalType, setDataMaritalType] = useState([]);
  const [dataNationality, setDataNationality] = useState([]);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState([]);
  const [countImage, setCountImage] = useState(0);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [previewUrlsUpdate, setPreviewUrlsUpdate] = useState([]);
  const [responseCheckingImage, setResponseCheckingImage] = useState({});

  const [errorMessage, setErrorMessage] = useState(null);
  const [value, setValue] = useState({
    uuid_person_fr: null,
    nik: "",
    full_name: "",
    place_of_birth: "",
    address: "",
    date_of_birth: null,
    gender_type_id: "",
    bloodTypeId: "",
    religionId: "",
    maritalTypeId: "",
    nationalityId: "",
    caseDescription: "",
    occupation: "",
    is_active: true,
    images: null,
  });
  // console.log(value, "value");
  // ==================== Get data master ==================== //
  const getDataGender = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/gender/get-list`);
      setDataGender(response.data?.data);
      getDataBloodType();
    } catch (err) {
      setDataGender([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataBloodType = async () => {
    try {
      const response = await fetchApi().get(`/blood-type/get-list`);
      setDataBloodType(response.data?.data);
      getDataReligion();
    } catch (err) {
      setDataBloodType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataReligion = async () => {
    try {
      const response = await fetchApi().get(`religion-type/get-list`);
      setDataReligion(response.data?.data);
      getDataMaritalType();
    } catch (err) {
      setDataReligion([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataMaritalType = async () => {
    try {
      const response = await fetchApi().get(`/marital-type/get-list`);
      setDataMaritalType(response.data?.data);
      getDataNationality();
    } catch (err) {
      setDataMaritalType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataNationality = async () => {
    try {
      const response = await fetchApi().get(`/nationality-type/get-list`);
      setDataNationality(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataNationality([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataImageByUuid = async () => {
    try {
      setIsLoadingImage(true);
      const response = await fetchApi().get(
        `/watchlist/get-image-watchlist/${argumentData?.uuid_person_fr}?uuidPersonFr=${argumentData?.uuid_person_fr}`
      );
      // console.log(response?.data?.data);
      const dataImage = [];

      for (const img of response?.data?.data || []) {
        const objectURL = await fetchImageUrl({
          imagePath: img?.image_path,
        });
        dataImage.push(objectURL);
      }
      // console.log(dataImage, "dataImage");
      setPreviewUrls(dataImage);
      setImages(dataImage);
      setCountImage(dataImage?.length);
      setIsLoadingImage(false);
    } catch (err) {
      setPreviewUrls([]);
      setCountImage(0);
      setIsLoadingImage(false);
      handleError(err);
    } finally {
      setIsLoadingImage(false);
    }
  };

  const goBack = () => {
    navigate(ROUTES.management_data.watchlist.watchlist_home);
  };
  // console.log(images?.length, 'img')
  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > 5) {
      handleWarning("Maksimal 5 gambar!");
      return;
    }

    const isFrontal = await checkFrontalImage(files[0]);
    if (files[0] && images?.length !== 0) {
      if (isFrontal?.checkScor?.status) {
        handleWarning(isFrontal?.response?.data?.message);
        fileInputRef.current.value = "";
        return;
      }
      // console.log(isFrontal, "isFrontal");
      if (isFrontal?.checkScor < 0.65 && images.length === 0) {
        handleWarning("Gambar pertama harus frontal!");
        fileInputRef.current.value = "";
        return;
      }
    }
    // console.log(responseCheckingImage , 'responseCheckingImage?.data?.uuid ')
    if (isFrontal?.response?.uuid !== argumentData?.uuid_person_fr) {
      handleWarning("Gambar Harus Orang yang sama dengan sebelumnya!");
      return;
    }
    // const newImages = [...images, ...files];
    // const newPreviewUrls = newImages.map((file) => URL.createObjectURL(file));

    const base64Images = await Promise.all(
      files.map((file) => fileToBase64(file))
    );
    const newImages = [...images, ...files];
    const newPreviewUrls = [...previewUrls, { url: base64Images }];
    const forUpdateImage = [...base64Images];
    setPreviewUrlsUpdate(forUpdateImage);

    setImages(newImages);
    setPreviewUrls(newPreviewUrls);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (e.target) {
      e.target.value = null;
    }
  };

  const handleRemoveImage = (index) => {
    previewUrls.forEach((url) => URL.revokeObjectURL(url));
    previewUrlsUpdate.forEach((url) => URL.revokeObjectURL(url));
    if (index === 0) {
      setImages([]);
      setPreviewUrls([]);
      setValue({
        uuid_person_fr: null,
        nik: "",
        full_name: "",
        place_of_birth: "",
        address: "",
        date_of_birth: "",
        gender_type_id: "",
        bloodTypeId: "",
        religionId: "",
        maritalTypeId: "",
        nationalityId: "",
        caseDescription: "",
        occupation: "",
        images: null,
      });
    } else {
      const newImages = images.filter((_, i) => i !== index);
      const newPreviewUrls = previewUrls.filter((_, i) => i !== index);
      setImages(newImages);
      setPreviewUrls(newPreviewUrls);
    }
  };

  const checkFrontalImage = async (image) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", image);

      const response = await fetchApi().post(
        "/watchlist/checking-image",
        formData
      );
      // console.log(response?.data);
      let checkScore;
      if (response?.data?.score) {
        checkScore = response?.data?.score;
        const res = response.data?.data;
        // console.log(response?.data?.data, " response?.data");
        // setValue({
        //   ...value,
        //   uuid_person_fr: res?.uuid,
        //   nik: res?.nik,
        //   full_name: res?.fullName,
        //   place_of_birth: res?.placeOfBirth,
        //   address: res?.address,
        //   date_of_birth: moment(res?.dateOfBirth).format("YYYY-MM-DD"),
        //   gender_type_id: res?.gender_id,
        //   bloodTypeId: res?.bloodTypeId,
        //   religionId: res?.religionId,
        //   maritalTypeId: res?.maritalTypeId,
        //   nationalityId: res?.nationalityTypeId,
        //   // caseDescription: res?.caseDescription,
        //   occupation: res?.occupation,
        // });
        setResponseCheckingImage(response.data);
      } else {
        setResponseCheckingImage({});
        // checkScore = false;
      }
      setIsLoading(false);
      return {
        response: response?.data?.data,
        checkScore,
      };
    } catch (error) {
      setIsLoading(false);
      console.error("Error checking frontal image", error);
      return error;
    }
  };

  const updateData = async () => {
    const body = {
      nik: value?.nik,
      full_name: value?.full_name,
      place_of_birth: value?.place_of_birth,
      address: value?.address,
      date_of_birth: value?.date_of_birth,
      gender_type_id: value?.gender_type_id,
      bloodTypeId: value?.bloodTypeId,
      religionId: value?.religionId,
      maritalTypeId: value?.maritalTypeId,
      nationalityId: value?.nationalityId,
      occupation: value?.occupation,
      caseDescription: value?.caseDescription,
      is_active: value?.is_active,
    };

    try {
      setIsLoading(true);

      const response = await fetchApi().put(
        `/watchlist/update/${argumentData?.id}`,
        body
      );
      setIsLoading(false);
      const dpoName = body.full_name;
      handleSuccess(`Data DPO ${dpoName} berhasil diperbarui`);
      goBack();

      setIsLoading(false);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const updateDataImgae = async () => {
    const formData = new FormData();
    const slicedData = previewUrls.slice(countImage);
    const combinedBase64 = slicedData
      .flat()
      .map((item) => item.url[0].split(",")[1]);
    combinedBase64.forEach((base64, index) => {
      const imageToFile = base64ToFile(
        `data:image/png;base64,${base64}`,
        `images${index}`
      );
      formData.append("images", imageToFile);
    });
    try {
      setIsLoading(true);

      const response = await fetchApiFormdata().post(
        `/watchlist/create-image-watchlist?uuid_person_fr=${argumentData?.uuid_person_fr}`,
        formData
      );
      setIsLoading(false);
      const dpoName = argumentData?.full_name;
      handleSuccess(`Gambar DPO ${dpoName} berhasil diperbarui`);
      goBack();

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value?.images === "") {
      setErrorMessage("Foto tidak boleh kosong");
    } else {
      setErrorMessage("");

      if (
        countImage < previewUrls?.length &&
        value.caseDescription !== argumentData?.caseDescription
      ) {
        updateDataImgae();
        updateData();
      } else if (countImage < previewUrls?.length) {
        updateDataImgae();
      } else if (value.caseDescription !== argumentData?.caseDescriptio) {
        updateData();
      } else {
        handleError('Ada Kesalahan')
      }
    }
  };
  // console.log(argumentData?.caseDescription, "old");
  // console.log(value?.caseDescription, "new");

  useEffect(() => {
    setValue((prevValue) => ({
      ...prevValue,
      ...argumentData,
      date_of_birth: isoStringToDateInput(argumentData?.date_of_birth),
      nik: decryptNik(argumentData?.nik),
    }));
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const formDataArray = images.map((images) => {
        return images;
      });

      setValue((prev) => ({
        ...prev,
        images: formDataArray, // Update value.images dengan formData
      }));
    }
  }, [images]); // Akan dijalankan setiap kali images berubah

  useEffect(() => {
    if (
      argumentData?.uuid_person_fr !== undefined &&
      argumentData.uuid_person_fr !== prevUuidRef.current
    ) {
      prevUuidRef.current = argumentData.uuid_person_fr;
      getDataImageByUuid();
    }
  }, [argumentData]);

  useEffect(() => {
    getDataGender();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p className="text-2xl font-bold" style={{ fontFamily: "Poppins" }}>
          Ubah Data Daftar Pencarian Orang
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-4 md:p-6">
          {/* Back Button */}
          <div className="flex justify-between items-center px-2 md:px-5 w-full">
            <div className="w-full md:w-2/4">
              <button
                type="button"
                onClick={goBack}
                // disabled
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-sm md:text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 cursor-pointer"
              >
                <ArrowLeftIcon className="h-5 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Image Upload Section */}
          <div className="flex justify-center items-center pb-5 px-2 md:px-5 w-full">
            <div className="w-full h-auto md:h-80 bg-white shadow-lg rounded-lg p-4 md:p-6 mt-6 md:mt-10">
              <h2 className="text-lg md:text-xl font-semibold mb-4">
                {5 - (previewUrls?.length || 0)} Slot tersisa (maks 5 gambar)
              </h2>

              {/* <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleImageChange}
                accept="image/*"
                disabled={uploading || previewUrls?.length === 5}
                className={`
              block text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4 file:rounded file:border-0
              file:text-sm file:font-semibold
              ${
                uploading || previewUrls?.length === 5
                  ? "file:bg-gray-300 file:text-gray-500 cursor-not-allowed"
                  : "file:bg-blue-500 file:text-white hover:file:bg-blue-600 cursor-pointer"
              }`}
              /> */}

              {errorMessage && (
                <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
              )}

              {uploading && (
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
                  <div
                    className="bg-blue-500 h-2.5 rounded-full transition-all"
                    style={{ width: `${100}%` }}
                  ></div>
                </div>
              )}
              {isLoadingImage && (
                <div className="w-full flex justify-start">
                  <div className="w-full px-0 md:px-4">
                    <div className="max-w-screen-lg mx-auto">
                      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
                        {/* Render default images for empty slots */}
                        {Array.from({ length: 5 - previewUrls.length }).map(
                          (_, index) => (
                            <div
                              key={`default-${index}`}
                              className="relative border-2 rounded-md"
                            >
                              <img
                                src="/asset/SpinnerTranparant2.gif" // Ganti dengan path gambar default Anda
                                alt="Default placeholder"
                                className="w-full h-24 md:h-36 object-cover rounded-md shadow-md opacity-50"
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!isLoadingImage && (
                <div className="w-full px-2 md:px-4">
                  <div className="max-w-screen-lg mx-auto">
                    <div className="mt-4 grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 sm:gap-3 md:gap-4">
                      {/* Render preview images */}
                      {previewUrls?.map((url, index) => (
                        <div
                          key={`preview-${index}`}
                          className="relative aspect-square"
                        >
                          <img
                            src={url?.url}
                            alt={`Preview ${index + 1}`}
                            className="w-full h-full object-cover rounded-md shadow-md border border-gray-200"
                          />
                          <button
                            onClick={() => handleRemoveImage(index)}
                            disabled={index < countImage}
                            className={`absolute top-1 right-1 ${
                              index < countImage
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-red-600 hover:bg-red-700"
                            } text-white text-xs p-1 rounded-full shadow-md transition-colors`}
                            aria-label="Remove image"
                          >
                            {index === 0 ? "🗑️" : "❌"}
                          </button>
                        </div>
                      ))}

                      {/* Render empty slots or upload trigger */}
                      {Array.from({
                        length: Math.max(0, 5 - (previewUrls?.length || 0)),
                      }).map((_, index) => (
                        <div
                          key={`empty-${index}`}
                          className="relative aspect-square border-2 border-dashed border-gray-300 rounded-md bg-gray-50 flex items-center justify-center"
                        >
                          <img
                            src="/asset/defaultImg.jpeg"
                            alt="Empty slot"
                            className="w-full h-full object-cover rounded-md opacity-50"
                          />
                          <input
                            type="file"
                            multiple
                            ref={fileInputRef}
                            onChange={handleImageChange}
                            accept="image/*"
                            disabled={uploading || previewUrls?.length === 5}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                          />
                          {/* {index === 0 && previewUrls?.length === 0 && (
                            <div className="absolute inset-0 flex items-center justify-center text-gray-500 text-xs text-center p-2">
                              Click to upload
                            </div>
                          )} */}
                        </div>
                      ))}
                    </div>

                    {/* Helper text */}
                    {/* {previewUrls?.length > 0 && (
                      <p className="mt-2 text-xs text-gray-500 text-center">
                        {5 - (previewUrls?.length || 0)} slots remaining (max 5
                        images)
                      </p>
                    )} */}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Form Fields - Responsive Grid */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_nik"
                className="block text-sm font-medium leading-6"
              >
                NIK
              </label>
              <div className="mt-1 md:mt-2">
                <input
                  id="register_face_nik"
                  name="register_face_nik"
                  type="text"
                  maxLength={16}
                  value={value.nik}
                  disabled
                  onChange={(e) => setValue({ ...value, nik: e.target.value })}
                  placeholder="Masukkan NIK"
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-3 md:mb-2 w-full md:w-2/4">
              <label
                htmlFor="register_face_full_name"
                className="block text-sm font-medium leading-6"
              >
                Nama Lengkap
              </label>
              <div className="mt-1 md:mt-2">
                <input
                  id="register_face_full_name"
                  name="register_face_full_name"
                  type="text"
                  placeholder="Masukkan Nama Lengkap"
                  value={value.full_name}
                  disabled
                  onChange={(e) =>
                    setValue({ ...value, full_name: e.target.value })
                  }
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Repeat the same responsive pattern for other fields */}
          {/* Place of Birth & Date of Birth */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_place_of_birth"
                className="block text-sm font-medium leading-6"
              >
                Tempat Lahir
              </label>
              <div className="mt-1 md:mt-2">
                <input
                  id="register_face_place_of_birth"
                  name="register_face_place_of_birth"
                  type="text"
                  placeholder="Masukan Tempat Lahir"
                  value={value.place_of_birth}
                  disabled
                  onChange={(e) =>
                    setValue({ ...value, place_of_birth: e.target.value })
                  }
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="mb-3 md:mb-2 w-full md:w-2/4">
              <label
                htmlFor="register_face_date_of_birth"
                className="block text-sm font-medium leading-6"
              >
                Tanggal Lahir
              </label>
              <div className="mt-1 md:mt-2">
                <input
                  id="register_face_date_of_birth"
                  name="register_face_date_of_birth"
                  type="date"
                  value={value.date_of_birth}
                  disabled
                  onChange={(e) =>
                    setValue({ ...value, date_of_birth: e.target.value })
                  }
                  placeholder="DD-MM-YYYY"
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Nationality & Occupation */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_nationality_id"
                className="block text-sm font-medium leading-6"
              >
                Kewarganegaraan
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_nationality_id"
                    name="register_face_nationality_id"
                    value={value.nationalityId}
                    disabled
                    onChange={(e) =>
                      setValue({ ...value, nationalityId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status
                    </option>
                    {Array.isArray(dataNationality) &&
                      dataNationality?.map((item) => (
                        <option value={item?.id} key={item?.id}>
                          {item?.nationality_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3 md:mb-2 w-full md:w-2/4">
              <label
                htmlFor="register_face_occupation"
                className="block text-sm font-medium leading-6"
              >
                Pekerjaan
              </label>
              <div className="mt-1 md:mt-2">
                <input
                  id="register_face_occupation"
                  name="register_face_occupation"
                  type="text"
                  placeholder="Masukan Pekerjaan"
                  value={value.occupation}
                  disabled
                  onChange={(e) =>
                    setValue({ ...value, occupation: e.target.value })
                  }
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Gender & Marital Status */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_gender_id"
                className="block text-sm font-medium leading-6"
              >
                Jenis Kelamin
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_gender_id"
                    name="register_face_gender_id"
                    value={value.gender_type_id}
                    disabled
                    onChange={(e) =>
                      setValue({ ...value, gender_type_id: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Jenis Kelamin
                    </option>
                    {Array.isArray(dataGender) &&
                      dataGender?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.gender_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3 md:mb-2 w-full md:w-2/4">
              <label
                htmlFor="register_face_marital_type"
                className="block text-sm font-medium leading-6"
              >
                Status Perkawinan
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_marital_type"
                    name="register_face_marital_type"
                    value={value.maritalTypeId}
                    disabled
                    onChange={(e) =>
                      setValue({ ...value, maritalTypeId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status Perkawinan
                    </option>
                    {Array.isArray(dataMaritalType) &&
                      dataMaritalType?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.marital_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Blood Type & Religion */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_blood_type_id"
                className="block text-sm font-medium leading-6"
              >
                Golongan Darah
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_blood_type_id"
                    name="register_face_blood_type_id"
                    value={value.bloodTypeId}
                    disabled
                    onChange={(e) =>
                      setValue({ ...value, bloodTypeId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Golongan Darah
                    </option>
                    {Array.isArray(dataBloodType) &&
                      dataBloodType?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.blood_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3 md:mb-2 w-full md:w-2/4">
              <label
                htmlFor="register_face_religion_id"
                className="block text-sm font-medium leading-6"
              >
                Agama
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_religion_id"
                    name="register_face_religion_id"
                    value={value.religionId}
                    disabled
                    onChange={(e) =>
                      setValue({ ...value, religionId: e.target.value })
                    }
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Agama
                    </option>
                    {Array.isArray(dataReligion) &&
                      dataReligion?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.religion_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Address (Full Width) */}
          <div className="flex justify-between items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full">
              <label
                htmlFor="register_face_address"
                className="block text-sm font-medium leading-6"
              >
                Alamat Tempat Tinggal
              </label>
              <div className="mt-1 md:mt-2">
                <textarea
                  id="register_face_address"
                  name="register_face_address"
                  value={value.address}
                  disabled
                  onChange={(e) =>
                    setValue({ ...value, address: e.target.value })
                  }
                  placeholder="Masukkan Alamat Tempat Tinggal"
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Case Description (Full Width) */}
          <div className="flex justify-between items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full">
              <label
                htmlFor="register_face_address"
                className="block text-sm font-medium leading-6"
              >
                Kasus Kriminalitas
              </label>
              <div className="mt-1 md:mt-2">
                <textarea
                  id="register_face_address"
                  name="register_face_address"
                  value={value.caseDescription}
                  disabled={isLoading}
                  onChange={(e) =>
                    setValue({ ...value, caseDescription: e.target.value })
                  }
                  placeholder="Masukkan Kasus Kriminalitas"
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Status (Full Width on mobile, half on desktop) */}
          <div className="flex justify-between items-center py-3 md:py-5 px-2 md:px-5 w-full">
            <div className="mb-3 md:mb-2 w-full md:w-2/4 md:mr-5">
              <label
                htmlFor="register_face_status_active"
                className="flex block text-sm font-medium leading-6"
              >
                Status <span className="ml-1 text-red-700">*</span>
              </label>
              <div className="mt-1 md:mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_status_active"
                    name="register_face_status_active"
                    required
                    disabled={isLoading}
                    value={value?.is_active}
                    onChange={(e) => {
                      setValue({ ...value, is_active: e.target.value });
                    }}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status
                    </option>
                    <option value="true">Aktif</option>
                    <option value="false">Tidak Aktif</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center justify-end px-2 md:px-5 md:mr-5">
            <button
              type="submit"
              className="h-11 flex w-full md:w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}
export default UpdateWatchlist;
